import Swal from "sweetalert2";
import "./notificationToast.css";

const GENERIC_ERROR_MESSAGES = new Set([
  "Une erreur est survenue, veuillez réessayer !",
  "Une erreur est survenue. Veuillez réessayer.",
  "Une erreur est survenue. Veuillez réessayer",
]);

const getToastContent = ({success, title, message}) => {
  const isSuccess = success === true;
  const isError = success === false || /erreur|échec|impossible|problème/i.test(title ?? "");
  const icon = isSuccess ? "success" : isError ? "error" : "info";

  let resolvedTitle = title?.trim();
  let resolvedMessage = message?.trim();

  if (!resolvedTitle || resolvedTitle === "Succès") {
    resolvedTitle = isSuccess ? "C’est fait" : isError ? "Action impossible" : "Information";
  } else if (resolvedTitle === "Erreur" || resolvedTitle === "Erreur ") {
    resolvedTitle = "Action impossible";
  }

  if (!resolvedMessage) {
    resolvedMessage = isSuccess
      ? "Votre demande a bien été prise en compte."
      : isError
        ? "Nous n’avons pas pu terminer cette action. Vérifiez vos informations, puis réessayez."
        : "Une nouvelle information est disponible.";
  } else if (GENERIC_ERROR_MESSAGES.has(resolvedMessage)) {
    resolvedMessage =
      "Un problème temporaire empêche cette action. Patientez quelques instants, puis réessayez.";
  }

  return {icon, title: resolvedTitle, message: resolvedMessage};
};

const fireNotificationToast = ({
  success,
  title,
  message,
  thenCallback,
  duration,
}) => {
  const content = getToastContent({success, title, message});
  // Les notifications restent non bloquantes, y compris lorsqu'une action
  // doit être exécutée après leur fermeture (navigation, changement d'état…).
  const timer = duration ?? (content.icon === "error" ? 7000 : 4500);

  return Swal.fire({
    toast: true,
    position: "bottom-end",
    icon: content.icon,
    iconColor:
      content.icon === "success"
        ? "#16a34a"
        : content.icon === "error"
          ? "#dc2626"
          : "#1a64b9",
    titleText: content.title,
    text: content.message,
    showConfirmButton: false,
    showCloseButton: true,
    closeButtonAriaLabel: "Fermer la notification",
    timer,
    timerProgressBar: Boolean(timer),
    allowEscapeKey: true,
    allowOutsideClick: true,
    returnFocus: false,
    customClass: {
      container: "help-clic-toast-container",
      popup: `help-clic-toast help-clic-toast--${content.icon}`,
      icon: "help-clic-toast__icon",
      title: "help-clic-toast__title",
      htmlContainer: "help-clic-toast__message",
      closeButton: "help-clic-toast__close",
      timerProgressBar: "help-clic-toast__progress",
    },
    didOpen: (toast) => {
      toast.setAttribute("role", content.icon === "error" ? "alert" : "status");
      toast.setAttribute("aria-live", content.icon === "error" ? "assertive" : "polite");
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  }).then(async (result) => {
    const completed =
      result.isConfirmed ||
      result.dismiss === Swal.DismissReason.timer ||
      result.dismiss === Swal.DismissReason.close ||
      result.dismiss === Swal.DismissReason.esc;

    if (completed && typeof thenCallback === "function") {
      await thenCallback();
    }

    return completed;
  });
};

export const showToastModal = ({
  success,
  title,
  message,
  thenCallback,
  duration,
}) =>
  fireNotificationToast({
    success,
    title,
    message,
    thenCallback,
    duration,
  });

export const ShowWelcomeModal = ({client, message, thenCallback}) =>
  fireNotificationToast({
    success: true,
    title: client ? "Bienvenue chez Help Clic" : "Bienvenue dans votre espace",
    message,
    thenCallback,
    duration: 8000,
  });

export {getToastContent};
